<template>
  <div class="box13">
    <div class="left-box">
      <div class="tagBox">
        <p>玩转新媒体运营</p>
        <p>科学全面</p>
        <p>零基础</p>
      </div>
      <div class="left-btn" @click="zixun('免费领取')">免费领取</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    zixun(name) {
      window.open("https://m.boxuegu.com/route/nmo");
     this.mai("新媒体+短视频-就业课","免费领取",0,null)
    },
  },
};
</script>

<style lang="scss" scoped>
.box13 {
  position: relative;
  width: 100%;
  height: 301px;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/newMedia/box13/bgc.png") no-repeat;
  background-size: cover;
  .left-box {
    position: absolute;
    top: 132px;
    left: 58px;
    font-size: 40px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    .tagBox {
      display: flex;
      width: 430px;
      justify-content: space-between;
      p {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }
    }
    .left-btn {
      width: 170px;
      height: 48px;
      background: #ffffff;
      border-radius: 8px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ff5533;
      line-height: 48px;
      text-align: center;
      margin-top: 49px;
      margin-left: -18px;
    }
  }
}
</style>
